import { api } from "./clientInstance";

export const fetchTokens = (lang) => api(`/tokens?lang=${lang}`);
